import { useContext } from "react";
import { AuthContext } from "./AuthProvider";
import type { AuthState } from "./AuthProvider";

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within an <AuthProvider>");
  return ctx;
}
